"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WpTransactionCreatedContract = void 0;
const WpTransactionEventDataContract_1 = require("./WpTransactionEventDataContract");
const events_1 = require("@getgreenline/events");
const WpCNPTransactionEventDataContract_1 = require("./WpCNPTransactionEventDataContract");
class WpTransactionCreatedContract extends events_1.EventsV2.EventModels.EventContractV2 {
    constructor(params) {
        super(params);
        this.isCNP = params.isCNP;
        const wpTransaction = params.isCNP
            ? events_1.GreenlineEvent.create(WpCNPTransactionEventDataContract_1.WpCNPTransactionEventDataContract, params.wpTransaction)
            : events_1.GreenlineEvent.create(WpTransactionEventDataContract_1.WpTransactionEventDataContract, params.wpTransaction);
        this.wpTransaction = wpTransaction;
    }
}
exports.WpTransactionCreatedContract = WpTransactionCreatedContract;
//# sourceMappingURL=WpTransactionCreatedContract.js.map